import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import secureLocalStorage from 'react-secure-storage';
import moment from 'moment';

const LoggedInToday = ({ firstLogin, onWFHUpdate }) => {
  const [visible, setVisible] = useState(false);
  const [userWfhButton, setUserWfhButton] = useState(false);
  const userName = secureLocalStorage.getItem('first_name');

  useEffect(() => {
    const now = moment();
    const eightAM = moment().startOf('day').add(7, 'hours');
    const sixPM = moment().startOf('day').add(18, 'hours');
    const today = moment().format('DD-MM-YYYY');
    const lastLoginDate = secureLocalStorage.getItem('last_login_date');
    const modalPreviouslyShown = secureLocalStorage.getItem('modal_shown_login') === 'true';

    if (modalPreviouslyShown || (firstLogin && lastLoginDate !== today && now.isAfter(eightAM) && now.isBefore(sixPM))) {
      setVisible(true);
      secureLocalStorage.setItem('modal_shown_login', 'true');
      secureLocalStorage.setItem('last_login_date', today);

      const timer = setTimeout(() => {
        setVisible(false);
      }, 180000);

      return () => clearTimeout(timer);
    }
  }, [firstLogin]);

  const handleWfhSwitchChange = (checked) => {
    setUserWfhButton(checked);
  };

  const handleOkClick = () => {
    setVisible(false);
    secureLocalStorage.removeItem('modal_shown_login');
    onWFHUpdate(userWfhButton);
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Modal
      show={visible}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Welcome</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ color: 'green' }}>You have successfully clocked in!</p>
        <div className='d-flex align-items-center gap-3'>
          <div>
            Hey { userName }, are you working from home / other location?
          </div>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={userWfhButton}
            onChange={handleWfhSwitchChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleOkClick}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoggedInToday;
